import { FORMAT_TYPE } from 'cyprus/enums';
import { formatValue } from 'cyprus/formats';

import { CandleTooltipProps } from './types';

import cn from './CandleHeatmap.module.scss';

export const CandleTooltip: React.FC<CandleTooltipProps> = ({ title, candle }) => {
  if (!candle) {
    return (
      <div className={cn.tooltip}>
        <div className={cn.information}>
          <p>No Data</p>
          <p>{title}</p>
        </div>
      </div>
    );
  }
  return (
    <div className={cn.tooltip}>
      <div className={cn.information}>
        <p>Candle</p>
        <p>{title}</p>
      </div>
      <div className={cn.information}>
        <p>Open</p>
        <p>{formatValue(candle.o, { format: FORMAT_TYPE.CURRENCY, invalid: '-' })}</p>
      </div>
      <div className={cn.information}>
        <p>High</p>
        <p>{formatValue(candle.h, { format: FORMAT_TYPE.CURRENCY, invalid: '-' })}</p>
      </div>
      <div className={cn.information}>
        <p>Low</p>
        <p>{formatValue(candle.l, { format: FORMAT_TYPE.CURRENCY, invalid: '-' })}</p>
      </div>
      <div className={cn.information}>
        <p>Close</p>
        <p>{formatValue(candle.c, { format: FORMAT_TYPE.CURRENCY, invalid: '-' })}</p>
      </div>
      <div className={cn.information}>
        <p>Volume</p>
        <p>{formatValue(candle.v, { format: FORMAT_TYPE.NUMBER, decimal: 5, invalid: '-' })}</p>
      </div>
    </div>
  );
};
